import { windowGlobal } from "../../utils/window-global";
import { defaultCountryCode, supportedCountryCodesSet } from "../../config/countries";
import { defaultLanguageCode, supportedLanguageCodes } from "../../config/languages";

export const getCountryWithLanguage = (fromUrl = false) => {
  if (fromUrl) {
    return { countryCode: getCountryCodeFromUrl(), languageCode: getLanguageCodeFromUrl() }
  }

  return { countryCode: getCountryCode(), languageCode: getLanguage() }
}

export const getCountryCodeFromUrl = () => {
  const availableMarkets = Array.from(supportedCountryCodesSet).join('|')
  const regExp = new RegExp(`/(${availableMarkets})(/{0,1}.*)`)
  const marketMatch = windowGlobal.location.pathname.match(regExp)
  let code
  if (!!marketMatch) {
    code = marketMatch[1]
  } else {
    code = localStorage.getItem('countryCode') ?? defaultCountryCode
  }
  return code
}

export const getLanguageCodeFromUrl = () => {
  const availableMarkets = Array.from(supportedCountryCodesSet).join('|')
  const availableLanguages = Array.from(supportedLanguageCodes).join('|')

  const regExp = new RegExp(`/(${availableMarkets})/(${availableLanguages})(/{0,1}.*)`)
  const matches = windowGlobal.location.pathname.match(regExp)

  let language
  if (!!matches) {
    language = matches[2]
  } else {
    language = localStorage.getItem('language') ?? defaultLanguageCode
  }
  return language
}

const getLanguage = () => {
  if (!windowGlobal) {
    return defaultLanguageCode
  }

  return localStorage.getItem('language') ?? defaultLanguageCode
}

export const getCountryCode = () => {
  if (!windowGlobal) {
    return defaultCountryCode
  }

  return localStorage.getItem('countryCode') ?? defaultCountryCode
}
